import React, { Component } from "react";
import styled from "styled-components";

import JobCardList from "../components/Jobs/JobCardList";
import FilterBar from "../components/FilterBar";

const Container = styled.div`
  max-width: 64rem;
  width: 100%;
  margin: auto;
  margin-top: 3rem;
  @media screen and (max-width: 64em) {
    padding: 0 2rem;
    max-width: calc(100%-4rem);
    overflow: hidden;
    position: relative;
  }
  @media screen and (max-width: 20em) {
    padding: 0 1rem;
  }
`;

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index == 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

if (typeof window !== `undefined`) {
  window.jobsToShow = 20;
}

class Jobs extends Component {
  constructor() {
    super();
    let jobsToShow = 20;
    if (typeof window !== `undefined`) {
      jobsToShow = window.jobsToShow;
    }
    this.state = {
      jobsToShow,
      jobs: []
    };
  }

  update() {
    const distanceToBottom =
      document.documentElement.offsetHeight -
      (window.scrollY + window.innerHeight);
    if (distanceToBottom < 100) {
      this.setState({ jobsToShow: this.state.jobsToShow + 10 });
    }
    this.ticking = false;
  }

  handleScroll = () => {
    if (!this.ticking) {
      this.ticking = true;
      requestAnimationFrame(() => this.update());
    }
  };
  componentDidMount() {
    window.addEventListener(`scroll`, this.handleScroll);
    this.setState({
      jobs: this.filterFromFourWeeks(this.props.data.jobs.edges)
    });
  }

  componentWillUnmount() {
    window.removeEventListener(`scroll`, this.handleScroll);
    window.jobsToShow = this.state.jobsToShow;
  }

  filterFromFourWeeks = array => {
    const fourWeeksAgo = new Date(
      new Date().getTime() - 4 * 7 * 24 * 60 * 60 * 1000
    ).toISOString();
    return array.map(e => e.node).filter(job => job.postedAt > fourWeeksAgo);
  };

  filterList = filters => {
    let jobs = this.filterFromFourWeeks(this.props.data.jobs.edges);
    const roleArray = filters.options[1].options;

    const filterLabels = options => {
      return options
        .filter(option => option.selected) //This should return an array of all options selected
        .map(filteredOptions => filteredOptions.label);
    };

    filters.options.map(option => {
      const roleArray = filterLabels(option.options);
      const label = camelize(option.label);
      jobs = jobs.filter(job => {
        return roleArray.indexOf(job[label]) > -1;
      });
    });

    this.setState({ jobs });
  };

  render() {
    return (
      <Container>
        <FilterBar
          jobs={this.filterFromFourWeeks(this.props.data.jobs.edges)}
          filterBy={[
            {
              label: "Country",
              key: "country"
            },
            {
              label: "Role",
              key: "role"
            },
            {
              label: "Position Type",
              key: "positionType"
            }
          ]}
          filterList={filters => this.filterList(filters)}
        />
        <JobCardList jobs={this.state.jobs.slice(0, this.state.jobsToShow)} />
      </Container>
    );
  }
}

export default Jobs;

export const JobsQuery = graphql`
  query getAllJobs {
    jobs: allJob(sort: { fields: [postedAt], order: DESC }) {
      edges {
        node {
          id
          title
          link
          location
          country
          positionType
          postedAt
          role
          company {
            name
            logo {
              url
              handle
              width
              height
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/jobs.js